import { initRecaptcha } from '../lib/initRecaptcha';

function init() {
	const button = document.querySelectorAll('.bxmodAuthShowLink');

	button.forEach((btn) => {
		btn.addEventListener('click', initRecaptcha);
		btn.addEventListener('mouseover', initRecaptcha);
	});
}

init();
